/* Product detail page: variant switching, gallery + zoom, quantity, AJAX add,
   accordion panels, mobile sticky add-to-cart. Styles: .pdp* in nabils-design.css. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nb-pdp]');
  if (!root) return;

  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-nb-variants]').textContent); } catch (e) { variants = []; }

  var optionCount = parseInt(root.getAttribute('data-nb-options'), 10) || 1;
  var idInput = root.querySelector('[data-nb-variant-id]');
  var priceEl = root.querySelector('[data-nb-price]');
  var oldEl = root.querySelector('[data-nb-old]');
  var unitEls = root.querySelectorAll('[data-nb-unit]'); // price line + Pflichtangaben table
  var stockEl = root.querySelector('[data-nb-stock]');
  var pctEl = root.querySelector('[data-nb-pct]');
  var atc = root.querySelector('[data-nb-atc]');
  var buy = root.querySelector('[data-nb-buy]');
  var stickyPrice = root.querySelector('[data-nb-sticky-price]');
  var stickyAtc = root.querySelector('[data-nb-sticky-atc]');

  /* ---------- Variant selection ---------- */
  function selectedOptions() {
    var out = [];
    root.querySelectorAll('[data-nb-optgroup]').forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      var on = g.querySelector('[data-nb-opt][aria-pressed="true"]');
      out[idx] = on ? on.getAttribute('data-value') : null;
    });
    return out;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var k = 0; k < optionCount; k++) {
        if (v.options[k] !== opts[k]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function setText(el, value) { if (el) el.textContent = value; }

  function applyVariant(v) {
    if (!v) return;
    if (idInput) idInput.value = v.id;
    setText(priceEl, v.price);

    if (oldEl) {
      if (v.compare) { oldEl.hidden = false; oldEl.lastChild.textContent = v.compare; }
      else { oldEl.hidden = true; }
    }
    if (pctEl) {
      if (v.pct) { pctEl.hidden = false; pctEl.textContent = '−' + v.pct + ' %'; }
      else { pctEl.hidden = true; }
    }
    unitEls.forEach(function (unitEl) {
      if (v.unit) { unitEl.hidden = false; unitEl.textContent = v.unit; }
      else { unitEl.hidden = true; }
    });
    if (stockEl) {
      stockEl.className = 'pinfo__stock ' + v.stockClass;
      var dot = '<span class="pinfo__stock-dot"></span>';
      stockEl.innerHTML = dot + v.stockLabel;
    }
    var sold = !v.available;
    [atc, stickyAtc].forEach(function (b) {
      if (!b) return;
      b.disabled = sold;
      b.classList.toggle('is-sold', sold);
      var label = b.querySelector('[data-nb-atc-label]') || b;
      label.textContent = sold ? 'Ausverkauft' : 'In den Warenkorb';
      if (b === atc && !sold) { label.textContent = 'In den Warenkorb'; }
    });
    if (buy) { buy.disabled = sold; }
    setText(stickyPrice, v.price);
    maxQty = v.max || 99;
    if (v.media >= 0 && window.nabilsGalShow) window.nabilsGalShow(v.media);
    setQty(getQty());
    showErr('');

    // reflect in URL without reloading
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  root.querySelectorAll('[data-nb-optgroup]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nb-opt]');
      if (!btn) return;
      group.querySelectorAll('[data-nb-opt]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      var legendVal = group.querySelector('[data-nb-opt-selected]');
      if (legendVal) legendVal.textContent = btn.getAttribute('data-value');
      applyVariant(findVariant(selectedOptions()));
    });
  });

  /* ---------- Quantity ---------- */
  var qtyInput = root.querySelector('[data-nb-qtyinput]');
  var qtyVal = root.querySelector('[data-nb-qtyval]');
  var maxQty = 99; // tracked stock of the selected variant (set by applyVariant)
  function getQty() { return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; }
  function setQty(n) {
    n = Math.min(maxQty, Math.max(1, n));
    if (qtyInput) qtyInput.value = n;
    if (qtyVal) qtyVal.textContent = n;
    if (minus) minus.disabled = n <= 1;
    if (plus) plus.disabled = n >= maxQty;
  }
  var minus = root.querySelector('[data-nb-qtyminus]');
  var plus = root.querySelector('[data-nb-qtyplus]');
  if (minus) minus.addEventListener('click', function () { setQty(getQty() - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(getQty() + 1); });
  var startVariant = idInput && variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
  if (startVariant && startVariant.max) maxQty = startVariant.max;
  setQty(getQty());

  /* ---------- Add to cart (AJAX, re-renders header cart) ---------- */
  var errEl = root.querySelector('[data-nb-atcerr]');
  function showErr(msg) {
    if (!errEl) return;
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
    // The sticky bar may have been used: bring the message into view
    if (msg) { var r = errEl.getBoundingClientRect(); if (r.top < 0 || r.bottom > window.innerHeight) errEl.scrollIntoView({ block: 'center' }); }
  }
  // A refused add (422, e.g. more than in stock): show why and sync the drawer with what really is in the cart
  function refused(data) {
    showErr(data && (data.description || data.message) || 'Dieser Artikel konnte nicht hinzugefügt werden.');
    if (window.nabilsCartState) window.nabilsCartState().then(function (d) {
      document.dispatchEvent(new CustomEvent('nabils:cart-refresh', { detail: d }));
    }).catch(function () {});
  }

  var adding = false;
  function addToCart(then) {
    var id = idInput ? idInput.value : null;
    if (!id || adding) return;
    adding = true;
    showErr('');
    [atc, stickyAtc, buy].forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: getQty() }], sections: ['header'], sections_url: window.location.pathname })
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (o) {
      if (!o.ok) { refused(o.data); return; }
      var data = o.data;
      var detail = {};
      if (data.sections && data.sections.header) {
        var doc = new DOMParser().parseFromString(data.sections.header, 'text/html');
        var body = doc.querySelector('[data-nb-cartbody]');
        var count = doc.querySelector('[data-nb-cartcount]');
        var cartEl = doc.querySelector('[data-nb-dialog="cart"]');
        if (body) detail.bodyHTML = body.innerHTML;
        if (count) detail.item_count = count.textContent;
        if (cartEl) detail.total_price = parseInt(cartEl.getAttribute('data-total'), 10);
      }
      document.dispatchEvent(new CustomEvent('nabils:cart-updated', { detail: detail }));
      if (then) then();
    }).catch(function () { window.location.href = '/cart'; }).finally(function () {
      adding = false;
      [atc, stickyAtc, buy].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); });
    });
  }

  [atc, stickyAtc].forEach(function (b) {
    if (!b) return;
    b.addEventListener('click', function (e) { e.preventDefault(); if (!b.disabled) addToCart(); });
  });
  if (buy) buy.addEventListener('click', function (e) {
    e.preventDefault();
    if (!buy.disabled) addToCart(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; });
  });

  /* ---------- Gallery ---------- */
  var gal = root.querySelector('[data-nb-gal]');
  if (gal) {
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-nb-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nb-thumb]'));
    var prev = root.querySelector('[data-nb-galprev]');
    var next = root.querySelector('[data-nb-galnext]');
    var cur = 0;

    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== cur; });
      thumbs.forEach(function (t, n) {
        var on = n === cur;
        t.classList.toggle('is-on', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var zoomable = isDesktop.matches && !!(slides[cur] && slides[cur].querySelector('[data-nb-zoom]'));
      gal.classList.toggle('gal--zoomable', zoomable);
      resetZoom();
    }
    window.nabilsGalShow = show;
    // Phones/tablets: swipe left/right to change the image
    if (slides.length > 1) {
      var sx = null, sy = 0;
      gal.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      gal.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(cur + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

    // Zoom on hover (desktop only), only for real images
    var isDesktop = window.matchMedia('(min-width: 1024px)');
    function activeImg() { var s = slides[cur]; return s ? s.querySelector('[data-nb-zoom]') : null; }
    function resetZoom() {
      slides.forEach(function (s) {
        var img = s.querySelector('[data-nb-zoom]');
        if (img) { img.style.transform = 'scale(1)'; img.style.transformOrigin = '50% 50%'; }
      });
    }
    gal.addEventListener('mousemove', function (e) {
      if (!isDesktop.matches) return;
      var img = activeImg();
      if (!img) return;
      var wrap = img.closest('[data-nb-slide]');
      var r = wrap.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      img.style.transform = 'scale(1.9)';
    });
    gal.addEventListener('mouseleave', resetZoom);
  }

  /* ---------- Accordion panels ---------- */
  function openPanel(id) {
    var panel = root.querySelector('#' + CSS.escape(id));
    if (!panel) return;
    if (tablist) {
      var idx = tabPanels.findIndex(function (p) { return p.panel === panel; });
      if (idx !== -1) { selectTab(idx); return; }
    }
    var btn = panel.querySelector('.panel__btn');
    var body = panel.querySelector('.panel__body');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (body) body.hidden = false;
    var sign = panel.querySelector('.panel__sign');
    if (sign) sign.textContent = '−';
  }
  /* ---------- Phones/tablets: accordion, one panel open at a time, height animated ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var accEase = 'cubic-bezier(.2, .7, .2, 1)';
  function setPanel(panel, open) {
    var btn = panel.querySelector('.panel__btn');
    var body = panel.querySelector('.panel__body');
    var sign = panel.querySelector('.panel__sign');
    if (!btn || !body || (btn.getAttribute('aria-expanded') === 'true') === open) return null;
    btn.setAttribute('aria-expanded', String(open));
    if (sign) sign.textContent = open ? '−' : '+';
    if (body._nbAnim) { body._nbAnim.cancel(); body._nbAnim = null; }
    if (reduceMotion.matches || !body.animate) { body.hidden = !open; return null; }
    var from = open ? 0 : body.offsetHeight;
    body.hidden = false;
    var to = open ? body.scrollHeight : 0;
    body.style.overflow = 'hidden';
    var anim = body.animate([{ height: from + 'px', opacity: open ? 0 : 1 }, { height: to + 'px', opacity: open ? 1 : 0 }],
      { duration: open ? 300 : 240, easing: accEase });
    body._nbAnim = anim;
    anim.onfinish = function () { body._nbAnim = null; body.style.overflow = ''; if (!open) body.hidden = true; };
    anim.oncancel = function () { body.style.overflow = ''; };
    return anim;
  }
  root.querySelectorAll('.panel').forEach(function (panel) {
    var btn = panel.querySelector('.panel__btn');
    if (!btn || !panel.querySelector('.panel__body')) return;
    btn.addEventListener('click', function () {
      var opening = btn.getAttribute('aria-expanded') !== 'true';
      var closing = null;
      if (opening) {
        // Close whichever other panel is open first
        root.querySelectorAll('.panel').forEach(function (other) {
          if (other !== panel) { var a = setPanel(other, false); if (a) closing = a; }
        });
      }
      setPanel(panel, opening);
      // A panel above may have collapsed: keep the opened header in view
      function keepInView() {
        var top = btn.getBoundingClientRect().top;
        var hdr = (document.querySelector('.site-header') || {}).offsetHeight || 0;
        if (top < hdr) window.scrollBy({ top: top - hdr - 12, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      if (opening) { if (closing) closing.addEventListener('finish', keepInView); else keepInView(); }
    });
  });
  /* ---------- Desktop: the same panels as tabs (phones keep the accordion) ---------- */
  var panelsEl = root.querySelector('.panels');
  var tabMQ = window.matchMedia('(min-width: 1024px)');
  var tablist = null, tabPanels = [];
  function selectTab(i, focus) {
    tabPanels.forEach(function (p, n) {
      var on = n === i;
      p.tab.setAttribute('aria-selected', String(on));
      p.tab.tabIndex = on ? 0 : -1;
      p.body.hidden = !on;
      p.btn.setAttribute('aria-expanded', String(on));
      if (p.sign) p.sign.textContent = on ? '−' : '+';
    });
    if (focus) tabPanels[i].tab.focus();
  }
  function enterTabs() {
    if (tablist || !panelsEl) return;
    var panels = [].slice.call(panelsEl.querySelectorAll('.panel[data-tab]'));
    if (panels.length < 2) return;
    tablist = document.createElement('div');
    tablist.className = 'ptabs';
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', 'Produktinformationen');
    tabPanels = panels.map(function (panel) {
      var body = panel.querySelector('.panel__body');
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'ptabs__tab';
      tab.id = 'tab-' + panel.id;
      tab.textContent = panel.getAttribute('data-tab');
      tab.setAttribute('role', 'tab');
      if (!body.id) body.id = 'tabpanel-' + panel.id;
      tab.setAttribute('aria-controls', body.id);
      body.setAttribute('role', 'tabpanel');
      body.setAttribute('aria-labelledby', tab.id);
      tablist.appendChild(tab);
      return { panel: panel, tab: tab, body: body, btn: panel.querySelector('.panel__btn'), sign: panel.querySelector('.panel__sign') };
    });
    tabPanels.forEach(function (p, n) { p.tab.addEventListener('click', function () { selectTab(n); }); });
    tablist.addEventListener('keydown', function (e) {
      var cur = tabPanels.findIndex(function (p) { return p.tab === document.activeElement; });
      if (cur === -1) return;
      var last = tabPanels.length - 1, to = null;
      if (e.key === 'ArrowRight') to = cur === last ? 0 : cur + 1;
      else if (e.key === 'ArrowLeft') to = cur === 0 ? last : cur - 1;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = last;
      if (to !== null) { e.preventDefault(); selectTab(to, true); }
    });
    panelsEl.insertBefore(tablist, panelsEl.firstChild);
    panelsEl.classList.add('panels--tabs');
    var hashed = window.location.hash ? tabPanels.findIndex(function (p) { return '#' + p.panel.id === window.location.hash; }) : -1;
    selectTab(hashed === -1 ? 0 : hashed);
  }
  function leaveTabs() {
    if (!tablist) return;
    tabPanels.forEach(function (p) { p.body.removeAttribute('role'); p.body.removeAttribute('aria-labelledby'); });
    tablist.remove();
    tablist = null; tabPanels = [];
    panelsEl.classList.remove('panels--tabs');
  }
  if (tabMQ.matches) enterTabs();
  tabMQ.addEventListener('change', function (e) { if (e.matches) enterTabs(); else leaveTabs(); });

  if (window.location.hash) openPanel(window.location.hash.slice(1));
  window.addEventListener('hashchange', function () { if (window.location.hash) openPanel(window.location.hash.slice(1)); });

  /* ---------- Cross-sell bundle builder ---------- */
  var cross = root.querySelector('[data-nb-cross]');
  if (cross) {
    var totalEl = cross.querySelector('[data-nb-cross-total]');
    var countEl = cross.querySelector('[data-nb-cross-count]');
    var addBtn = cross.querySelector('[data-nb-cross-add]');
    function recalc() {
      var cents = 0, n = 0, ids = [];
      cross.querySelectorAll('[data-nb-cross-item]').forEach(function (it) {
        var self = it.getAttribute('data-self') === 'true';
        var on = self || it.getAttribute('aria-checked') === 'true';
        if (on) {
          cents += parseInt(it.getAttribute('data-price'), 10) || 0;
          n += 1;
          var vid = it.getAttribute('data-variant');
          if (vid) ids.push(vid);
        }
      });
      if (countEl) countEl.textContent = n + (n === 1 ? ' Artikel' : ' Artikel') + ' zusammen';
      if (totalEl) totalEl.textContent = cross.getAttribute('data-money-prefix') + (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + cross.getAttribute('data-money-suffix');
      return ids;
    }
    cross.querySelectorAll('[data-nb-cross-item]').forEach(function (it) {
      if (it.getAttribute('data-self') === 'true') return;
      it.addEventListener('click', function () {
        it.setAttribute('aria-checked', it.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
        it.classList.toggle('is-on');
        recalc();
      });
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      var ids = recalc();
      if (!ids.length) return;
      var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: ['header'], sections_url: window.location.pathname })
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      }).then(function (o) {
        if (!o.ok) { refused(o.data); return; }
        var data = o.data;
        var detail = {};
        if (data.sections && data.sections.header) {
          var doc = new DOMParser().parseFromString(data.sections.header, 'text/html');
          var body = doc.querySelector('[data-nb-cartbody]');
          var count = doc.querySelector('[data-nb-cartcount]');
          var cartEl = doc.querySelector('[data-nb-dialog="cart"]');
          if (body) detail.bodyHTML = body.innerHTML;
          if (count) detail.item_count = count.textContent;
          if (cartEl) detail.total_price = parseInt(cartEl.getAttribute('data-total'), 10);
        }
        document.dispatchEvent(new CustomEvent('nabils:cart-updated', { detail: detail }));
      }).catch(function () { window.location.href = '/cart'; });
    });
    recalc();
  }

  /* ---------- Mobile sticky add-to-cart ---------- */
  var sticky = root.querySelector('[data-nb-sticky]');
  var actions = root.querySelector('[data-nb-actions]');
  // Shown once the buy buttons have scrolled out above the viewport. Checked on every scroll (not an
  // IntersectionObserver: a jump from far below straight to the top never crosses the threshold).
  if (sticky && actions) {
    var mobileMq = window.matchMedia('(max-width: 1023px)');
    var ticking = false;
    var updateSticky = function () {
      ticking = false;
      var shown = mobileMq.matches && actions.getBoundingClientRect().bottom < 0;
      if (sticky.classList.contains('is-shown') === shown) return;
      sticky.classList.toggle('is-shown', shown);
      sticky.setAttribute('aria-hidden', String(!shown));
    };
    var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    updateSticky();
  }
})();
